module.exports = __webpack_public_path__ + "img/dcmm_8.04b2c47f.png";